import * as R from 'ramda';
import { CustomError } from '../errors';
import { Logger } from './logger';

export default class LocalLogger implements Logger {
  private logConsole: Console = console;

  updateFromMetaData(): void {}

  log(error: Error): void {
    this.logConsole.error(`${error.constructor.name} Error: `, error);
    if (R.is(CustomError, error)) {
      const customError = error as CustomError;
      if (customError.nestedError && R.is(CustomError, customError.nestedError)) {
        this.logConsole.error('-- Nested custom error:');
        this.log(customError.nestedError);
      } else if (customError.nestedError) {
        this.logConsole.error('-- Nested Error: ', customError.nestedError);
      }
    }
  }

  debug(message: string, optionalParams: unknown[]): void {
    this.logConsole.log(message, optionalParams);
  }

  error(message: string, error: Error | null, ...optionalParams: unknown[]): void {
    this.logConsole.log(message, optionalParams);
    if (error) {
      this.log(error);
    }
  }
}
